var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"action-cable-provider"},[_vm._t("default",null,{"cableConsumer":_vm.consumer,"cableSubscription":_vm.subscription})],2)}
var staticRenderFns = []

export { render, staticRenderFns }